import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'antd';

import { getIconComponent } from './icons';
import { NotificationFirebaseService } from '../../services/firebase/NotificationFirebaseService';

function ChatMenu({ menu, onClick, isActive, isCollapsed }) {
  const [notification, setNotification] = useState({});

  useEffect(() => {
    const listener = NotificationFirebaseService().listenAdminNotification(
      (adminNotification) => setNotification(adminNotification),
    );

    return () => listener();
  }, []);

  const IconComponent = getIconComponent(menu.icon);
  const hasNotifications =
    notification.notReadConversationIds &&
    notification.notReadConversationIds.length > 0;

  return (
    <Link
      to={menu.url}
      className={`nav-item ${isActive ? 'active' : ''}`}
      onClick={() => onClick(menu)}>
      <span className='nav-item-icon'>
        {IconComponent && <IconComponent weight='fill' />}
      </span>
      {!isCollapsed && (
        <Badge dot={hasNotifications} className='chat-badge'>
          <span className='nav-item-text'>{menu.text}</span>
        </Badge>
      )}
    </Link>
  );
}

export default ChatMenu;
